import { RequestDataDto } from "@app/core/dto/request-data.dto";
import { ActionCommand } from "../action-command-interface";
import { ActionCommandResponseDto } from "@app/core/dto/action-command-response.dto";

export class NavigateByUrlCommand implements ActionCommand {
  constructor() { }

  async execute(actionData: any, requestData: RequestDataDto): Promise<ActionCommandResponseDto> {
    return
  }
}